import styled from "styled-components";

export const FooterContainer = styled.footer`
  padding: 3rem 0;
  text-align: center;
  color: var(--dark-gray);
  font-size: 1.2rem;
`;

export const Copy = styled.p`
  margin: 0 auto;
`;
